import {createEntityService} from "base/entity/service";
import {
    createTanque,
    createTanques,
    tanque_api_adapter,
    tanques_api_adapter,
} from "saneamiento/model";

const entityService = createEntityService(
    "/api/infrastructures/tanques",
    createTanque,
    createTanques,
    tanque_api_adapter,
    tanques_api_adapter
);

const TanqueService = {
    getList(filter, sort, order, format = null) {
        return entityService.getList(filter, null, sort, order, format);
    },

    getPaginatedList(filter, page, sort, order) {
        return entityService.getList(filter, page, sort, order);
    },

    getFeatures(filter) {
        return entityService.getFeatures(filter);
    },

    getBySearchText(searchText) {
        return entityService.getBySearchText(searchText);
    },

    get(id) {
        return entityService.get(id);
    },

    create(tanque) {
        return entityService.create(tanque);
    },

    update(tanque) {
        return entityService.update(tanque);
    },

    updateWithPatch(tanque) {
        return entityService.updateWithPatch(tanque);
    },

    delete(tanqueId) {
        return entityService.delete(tanqueId);
    },

    approveChanges(id) {
        return entityService.approveChanges(id);
    },

    rejectChanges(id, comments) {
        return entityService.rejectChanges(id, comments);
    },
};

export default TanqueService;
